const images = {
  loginBanner: require("./images/background.jpg"),
  logo: require("./images/LOGO.jpg"),
};

export { images };
